import { HomePage, NotificationTestPage, CompetitionPage, CompetitionListPage, UserListPage, UserEditPage } from './pages';
import { withNavigationWatcher } from './contexts/navigation';
import AppSettings from './pages/settings/app-settings';

const routes = [
    {
        path: '/home',
        element: HomePage
    },
    {
        path: '/settings/notifications/test',
        element: NotificationTestPage
    },
    {
        path: '/settings/app',
        element: AppSettings
    },
    {
        path: '/user/list',
        element: UserListPage
    },
    {
        path: '/user/edit/:userId',
        element: UserEditPage
    },
    {
        path: '/competition/list',
        element: CompetitionListPage
    },
    {
        path: '/competition/:competitionId/:section?/:setting1?/:setting2?/:setting3?/:setting4?',
        element: CompetitionPage
    }
   
   
];

export const appRoutes = routes.map(route => {
    return {
        ...route,
        element: withNavigationWatcher(route.element, route.path)
    };
});
